import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-78" data-mp="1l9o779vjm1m9">
      <div className="mx-auto max-w-2xl" data-id="element-79" data-mp="1ge0fontl8wdl">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-80" data-mp="1gauuhjo2yen5">
          Questions fréquentes
        </h2>

        <div className="mt-10 space-y-3" data-id="element-81" data-mp="2924mxdrt5hie">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.q} className="overflow-hidden rounded-xl bg-white" data-id="element-82" data-mp="1z3p03mztcuep" data-mpi={index}>
                <h3 data-id="element-83" data-mp="smv2kgf18i6z">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40" data-id="element-84" data-mp="snd5tx043woe">
                    <span className="text-sm font-bold text-ink" data-id="element-85" data-mp="ueodvxd9qfak">{faq.q}</span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-86" data-mp="fji6p72fsafn" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-87" data-mp="3syod6fixr93i">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-88" data-mp="3swk13aavv3s5">
                      <p className="px-6 pb-5 text-sm leading-relaxed text-ink/60" data-id="element-89" data-mp="1uhw72rfd0aky">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}